module.exports = __webpack_public_path__ + "p1_img1.jpg?92197320ccbbb9b1b3eb66cf6284e491";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img1.jpg
// module id = 98
// module chunks = 0